import { zIndex } from 'constants/index';
import React from 'react';
import { Modal, ColorMode, palette } from '@landr/maestro';
import { useSearchBarContext } from 'components/Filters/context/SearchBarContext/SearchBarContext';
import styled from 'styled-components';
import * as Styled from '../styled';

const StyledModal = styled(Modal)`
    margin: 0;
    color: unset;
    max-width: 100%;
    max-height: var(--viewport-height, 100%);
    align-self: flex-start;
`;

const ModalContent = styled(Modal.Content)`
    background-color: ${palette('neutral.800')};
`;

export const _SuggestionsWrapper = ({
    children,
    isModal,
    anchorRef,
    isSuggestionsOpen,
}: {
    children: React.ReactNode;
    anchorRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
    isSuggestionsOpen: boolean;
}) => (
    <>
        {isModal ? (
            <StyledModal isOpen={isSuggestionsOpen} isFull translate="no">
                <ColorMode mode="dark">
                    <ModalContent>{children}</ModalContent>
                </ColorMode>
            </StyledModal>
        ) : (
            <Styled.Popper
                translate="no"
                zIndex={zIndex.searchBar}
                isOpen={isSuggestionsOpen}
                anchorRef={anchorRef}
                popperOptions={{
                    placement: 'bottom',
                    modifiers: [
                        {
                            name: 'offset',
                            options: {
                                offset: [0, 0],
                            },
                        },
                        {
                            name: 'flip',
                            enabled: false,
                        },
                    ],
                }}
            >
                {children}
            </Styled.Popper>
        )}
    </>
);

const SuggestionsWrapper = ({
    children,
    anchorRef,
    isModal,
}: {
    children: React.ReactNode;
    anchorRef: React.RefObject<HTMLDivElement>;
    isModal: boolean;
}) => {
    const { isSuggestionsOpen } = useSearchBarContext();

    return (
        <_SuggestionsWrapper
            isModal={isModal}
            anchorRef={anchorRef}
            isSuggestionsOpen={isSuggestionsOpen}
        >
            {children}
        </_SuggestionsWrapper>
    );
};

export default SuggestionsWrapper;
